// partner school where sunshine agents get licensed and take their continuing education
export const SUNSHINE_LICENSING_SCHOOL_URL =
  'https://www.nationalonlineinsuranceschool.com/partners/sunshine-life-health-advisors';
